export default __webpack_public_path__ + "static/media/Layer 0.c02c5f05.png";